module.exports = __webpack_public_path__ + "static/img/route_bg.43599b32.png";